import { encodeSortSpec, parseSortSpec, type SortDirection } from '@solum/sdk'

/** The persisted view grammar is flat pairs; keep its surgery in one place. */
export function setSortTerm(
  sortSpec: string[], key: string, direction: SortDirection | undefined, additive: boolean,
): string[] {
  const terms = parseSortSpec(sortSpec)
  const at = terms.findIndex((term) => term.key === key)
  const nextDirection = direction ?? (at >= 0 && terms[at]?.direction === 'asc' ? 'desc' : 'asc')
  if (!additive) return encodeSortSpec([{ key, direction: nextDirection }])
  if (at >= 0) terms[at] = { key, direction: nextDirection }
  else terms.push({ key, direction: nextDirection })
  return encodeSortSpec(terms)
}

export function removeSortTerm(sortSpec: string[], key: string): string[] {
  return encodeSortSpec(parseSortSpec(sortSpec).filter((term) => term.key !== key))
}

export function reorderColumns(columns: string[], key: string, toIndex: number): string[] {
  const from = columns.indexOf(key)
  if (from < 0) return columns
  const next = columns.filter((column) => column !== key)
  next.splice(Math.max(0, Math.min(next.length, toIndex)), 0, key)
  return next
}

/**
 * A header LABEL click (#2375): ascending → descending → off. Shift adds the
 * column as a further key instead of replacing the order. The column ⋮ menu's
 * explicit "Sort ascending/descending" still sets a direction outright.
 */
export function cycleSortTerm(sortSpec: string[], key: string, additive: boolean): string[] {
  const current = parseSortSpec(sortSpec).find((term) => term.key === key)
  if (current?.direction === 'desc') return removeSortTerm(sortSpec, key)
  return setSortTerm(sortSpec, key, current ? 'desc' : 'asc', additive)
}
